import { colors, typographyCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { LegacyPopover } from '@creditornot/cb-popover';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

type Props = {
  info: React.ReactNode;
  icon: React.ReactNode;
};

const PopoverContent = styled.div`
  ${typographyCss.Body3()}
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${color.bgFillTransparent};
  box-shadow: 0 0 12px 0 ${cssThemedValue({ light: colors.pepper12, dark: colors.salt12 })};
`;

export const InfoIcon = ({ info, icon }: Props) => {
  return (
    <div>
      <LegacyPopover content={<PopoverContent>{info}</PopoverContent>} placement="top" showOnClick={false}>
        <IconContainer>{icon}</IconContainer>
      </LegacyPopover>
    </div>
  );
};
